import { ENDPOINT_BASE_URL } from "../../../configs/config";
import { fetchJWT } from "../../test-utils/login";
import {
  filterCryptoAssets,
  reformatPortfolioTrackRecordRoundFourDigit,
} from "../utils/portfolio-processor";

export const fetchPortfolioTrackRecordsRoundFourDigit = async () => {
  try {
    const response = await fetch(
      `${ENDPOINT_BASE_URL}/portfolio_track_records?page=1&limit=2`
    );

    if (!response.ok) {
      throw new Error("Failed to fetch portfolio track records");
    }

    const data = await response.json();
    return reformatPortfolioTrackRecordRoundFourDigit(data?.data?.[0]);
  } catch (error) {
    console.error("Error fetching portfolio track records:", error);
    throw error;
  }
};

export const fetchPortfolioLatestData = async () => {
  try {
    const token = await fetchJWT();
    const response = await fetch(`${ENDPOINT_BASE_URL}/portfolio_latest`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch portfolio latest data");
    }

    const data = await response.json();
    const payload = Array.isArray(data?.data) ? data.data : data;
    return filterCryptoAssets(payload);
  } catch (error) {
    console.error("Error fetching portfolio latest data:", error);
    throw error;
  }
};

export const fetchMonitorAprAttributes = async () => {
  try {
    const token = await fetchJWT();
    const response = await fetch(`${ENDPOINT_BASE_URL}/monitor_apr_attribute`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to fetch monitor APR attributes");
    }

    const data = await response.json();
    const payload = Array.isArray(data?.data) ? data.data : data;
    return Array.isArray(payload) ? payload : [];
  } catch (error) {
    console.error("Error fetching monitor APR attributes:", error);
    throw error;
  }
};
